import { COMMON_PAGE_TEXT } from '../../../../components/lang';

export const CARD_PAGE_TEXT = {
  ...COMMON_PAGE_TEXT,

  OPTIONS_LABEL: {
    LANGUAGE_QUALIFICATION_TEST_TYPE: {
      IELTS: 'International English Language Testing System (IELTS)',
      TOEFL: 'Test of English as a Foreign Language (TOEFL) - Internet based',
    },
  },
  TEST_TYPE: 'Test Type',
  TEST_DATE: 'Test Date',
  LANGUAGE_QUALIFICATION: 'Language Qualification',
  TEST_RESULT_ANNOUNCED: 'Test Result Announced?',
  I_WILL_UPDATE_RESULT_AT: 'I will update result by',
  LISTENING: 'Listening',
  READING: 'Reading',
  SPEAKING: 'Speaking',
  WRITING: 'Writing',
  OVERALL_BAND_SCORE: 'Overall Band Score',
  TOTAL_SCORE: 'Total Score',
  CERTIFICATE: 'Certificate(s)',
  TRANSCRIPT: 'Transcript(s)',
  OTHER_DOCUMENTS: 'Other Documents',
  ENTRY: 'Entry',
  PAY: 'Pay',
  EDIT: 'Edit',
  ADD: 'Add',
  VIEW: 'View',
};

export const APPLICATION_CREATION_TEXT = {
  APPLICATION_CREATION_QUALIFICATION: 'Create Application - Qualification',
  APPLICATION_CREATION_PROGRAMME: 'Create Application - Programme',
};

export const APPLICATION_CARD_LIST_TEXT = {
  APPLICATION: 'Application List',
  NO_APPLICATION: 'You have not created any applications. ',
};

export const ACADEMIC_QUALIFICATION_FORM_ITEM_TEXT = {
  ACADEMIC_QUALIFICATION: 'Academic Qualification - ',
  DEGREE: 'Degree',
};

export const DEGREE_FORM_TITLE: string[] = [
  'First',
  'Second',
  'Third',
  'Forth',
  'Fifth',
];

export const ACADEMIC_QUALIFICATION_FORM_TEXT = {
  LEVEL_OF_DEGREE: 'Level of Degree',
  NAME_OF_PROGRAMME_AWARD: 'Name of Programme/Award',
  PRESENT_STUDYING_QUALIFICATION: 'Present studying qualification?',
  FROM: 'From',
  TO: 'To',
  MODE_OF_STUDY: 'Mode of Study',
  CURRENT_STUDY_YEAR: 'Current Study Year',
  NAME_OF_INSTITUTION: 'Name of Institution',
  COUNTRY_REGION_OF_INSTITUTION: 'Country/Region of Institution',
  MEDIUM_OF_INSTRUCTION: 'Medium of Instruction',
  FIELD_OF_STUDY: 'Field of Study',
  MEDIUM_OF_QUALIFICATION: 'Means of Qualification',
  QUALIFICATION_STATUS: 'Qualification Status',
  HAVE_ACADEMIC_CREDENTIAL: 'I have Academic Credential',
  ONLINE_VERIFICATION_CODE: 'Online verification code (在線驗證碼)',
  HAVE_DEGREE_CERTIFICATE: 'I have Degree Certificate',
  DEGREE_CERT_ONLINE_VERIFICATION_CODE:
    'Degree Cert Online Verification Code (在線驗證編碼)',
  DATE_OF_AWARD: 'Date of Award',
  AWARD_CLASSIFICATION: 'Award Classification',
  EXPECT_UPDATE_DATE: 'I will update the qualification status and result by',
  DATE_OF_WITHDRAW: 'Date of Withdrawal',
  NO_OFFICIAL_MARK_GPA: 'No Official Mark/GPA showing in transcript',
  AWARD_CUM_GPA_AVG_MARK: 'Award/Cum. GPA or Avg Mark',
  CONVERTED_SCORE: 'Converted Score (Based on 4.0)',
  NO_OFFICIAL_RANK: 'No Official Rank in Class with proof',
  RANK_IN_CLASS: 'Rank in Class',
  SAVE: 'Save',
  SAVE_AND_ADD: 'Save and Add',
};
export const APPLICATION_TEXT = {
  APPLICATION: 'Application',
};

export const APPLICATION_CARD_TEXT = {
  ENTRY: 'Entry',
};

export const APPLICATION_CARD_INFO_TEXT = {
  DECLARATION_REQUIRED: 'Declaration Required',
};
